import { render, staticRenderFns } from "./ComAppName.vue?vue&type=template&id=faa12948&scoped=true&"
import script from "./ComAppName.vue?vue&type=script&lang=js&"
export * from "./ComAppName.vue?vue&type=script&lang=js&"
import style0 from "./ComAppName.vue?vue&type=style&index=0&id=faa12948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa12948",
  null
  
)

export default component.exports